var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_777_1677)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13192 0.048584C7.67686 0.048584 7.24531 0.240311 6.9398 0.576899L5.99549 1.62288L5.05333 0.58329C4.45726 -0.070713 3.44246 -0.11971 2.78657 0.474645C2.13069 1.069 2.08155 2.08089 2.67761 2.7349C2.98099 3.06722 3.41041 3.25895 3.86333 3.25895H8.1362C9.02068 3.30369 9.77484 2.62625 9.82184 1.74431C9.86671 0.86236 9.18732 0.110363 8.30284 0.0634961C8.24729 0.0613658 8.19174 0.0613658 8.13833 0.0634961L8.13406 0.048584H8.13192ZM3.85906 2.15546C3.57918 2.15546 3.35059 1.92751 3.35059 1.64844C3.35059 1.36937 3.57918 1.14143 3.85906 1.14143C4.0022 1.14143 4.13893 1.20108 4.23507 1.30759L4.99991 2.15972L3.85906 2.15546ZM6.9998 2.15547H8.13211L8.1428 2.15121C8.42267 2.15121 8.65127 1.92326 8.65127 1.64419C8.65127 1.36513 8.42267 1.13718 8.1428 1.13718C7.99965 1.13718 7.86079 1.19683 7.76465 1.30335L6.9998 2.15547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6999 4.47537V5.40418C11.6999 5.68964 11.4671 5.92184 11.1808 5.92184H6.61951V3.9577H11.1787C11.4649 3.9577 11.6978 4.18778 11.6999 4.47324C11.6999 4.47324 11.6999 4.47324 11.6999 4.47537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53846 5.92397H0.81908C0.532798 5.92397 0.299927 5.69177 0.299927 5.40631V4.47537C0.299927 4.18991 0.532798 3.9577 0.81908 3.9577H5.53846V5.92397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4074 12.0485H6.61951V7.01038H10.9266V11.5309C10.9266 11.8163 10.6937 12.0485 10.4074 12.0485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07129 7.01038H5.53857V12.0485H1.59044C1.30416 12.0485 1.07129 11.8163 1.07129 11.5309V7.01038Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_777_1677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.048584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerks);
export default __webpack_public_path__ + "static/media/perks.5d750b3fce46ea399752bb9b37b9ad84.svg";
export { ForwardRef as ReactComponent };